<!--
* @Name：采购订单物料信息明细
* @Author: 刘玉
* @Date: 2021-12-02 15:43:31
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:31
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row>
        <span>单价：</span>
        <span>{{ item.price }}</span>
      </van-row>
      <van-row>
        <span>价格来源：</span>
        <span>{{ item.priceSourceDict | dictFilter(priceSourceOptions) }}</span>
      </van-row>
      <van-row>
        <span>币种：</span>
        <span>{{ currencyDict | dictFilter(currencyDictOptions) }}</span>
      </van-row>
      <van-row>
        <span>税率：</span>
        <span>{{ item.taxRate | dictFilter(taxRateDictOptions) }}</span>
      </van-row>
      <van-row>
        <span>采购数量：</span>
        <span>{{ item.purchaseQty }}</span>
      </van-row>
      <van-row>
        <span>到货日期：</span>
        <span>{{ item.deliveryDate }}</span>
      </van-row>
      <van-row>
        <span>汇率类别：</span>
        <span>{{ item.exchangeRateTypeDict | dictFilter(exchangeRateTypeOptions) }}</span>
      </van-row>
      <van-row>
        <span>服务费率：</span>
        <span>{{ item.serviceRate }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
import { selectDetail } from '@/api/purchaseOrder'
import { selectModifyDetail } from '@/api/purchaseOrderModify'
export default {
  name: 'MaterialDetails',
  data() {
    return {
      // poCreateHeadId: this.$store.getters.businessKey,
      poCreateHeadId: this.$route.query.businessKey,
      detailsList: []
    }
  },
  props: {
    todoName: {
      type: String,
      required: true
    },
    currencyDict: {
      type: String
    }
  },
  computed: {
    priceSourceOptions() {
      return this.$store.getters.dicts.price_source
    },
    exchangeRateTypeOptions() {
      return this.$store.getters.exchange_rate_type
    },
    currencyDictOptions() {
      return this.$store.getters.dicts.currency_dict
    },
    taxRateDictOptions() {
      return this.$store.getters.dicts.tax_rate
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      if (this.todoName === 'PomApproval') {
        const response = await selectModifyDetail(this.poCreateHeadId)
        this.detailsList = response.data
      } else if (this.todoName === 'PoApproval') {
        // const detailsResp = await selectDetail(this.$store.getters.businessKey)
        const detailsResp = await selectDetail(this.$route.query.businessKey)
        this.detailsList = detailsResp.data
      }
    }
  }
}
</script>
